<app-header login= 'yes'></app-header>

<div class="responsive">
    <div class="container-fluid">



        <div class="row">
         


            <div class="col-md-12">
                <div class="row margin-b">
                    <div class="col-md-12">
                        <app-sub-header title="Filters"></app-sub-header>

                    </div>
                </div>


                <div class="row">
                    <div class="col-md-12">
                        <app-shared-filter (setAddress)="outputData($event)"></app-shared-filter>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>